import React, { createContext, useContext, useState, useEffect } from 'react';
import Context from './context';

const VonjoModalContext = createContext();

export const useVonjoModal = () => useContext(VonjoModalContext);

export const VonjoModalProvider = ({ children }) => {
  const context = useContext(Context);
  const [isModalVisible, setModalVisible] = useState(false);
  const currentUser = context.auth.getCurrentUser();
  const isPatient = currentUser.current_profile_type === 'Patient';
  const currentPath = window.location.pathname;
  const allowedPaths = ['/spv/', '/member/join/support'];

  useEffect(() => {
    const matchedWithMentor =
      sessionStorage.getItem('patientPartner') !== null || currentUser.matched_with_mentor == true;
    const isVonjoPatient = currentUser?.current_profile?.surgeries_or_treatments?.includes('VONJO');
    const shouldShowModal =
      !allowedPaths.some((allowedPath) => currentPath.includes(allowedPath)) &&
      isPatient &&
      matchedWithMentor &&
      isVonjoPatient;
    setModalVisible(shouldShowModal);
  }, [currentPath]);

  return <VonjoModalContext.Provider value={{ isModalVisible }}>{children}</VonjoModalContext.Provider>;
};
